<template>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">确认删除</v-card-title>
        <v-card-text>
          确定要删除课程章节 "{{ item.lessonName }}" 吗？此操作无法撤销。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">取消</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete">确认删除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { courseApi } from '@/api/course'

export default {
  name: 'DeleteCourseLessonConfirmation',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    open(item) {
      this.dialog = true;
      this.item = item;
      console.log('item = ', item);
    },
    close() {
      this.dialog = false
    },
    async confirmDelete() {
      try {
        await courseApi.deleteCourseLesson(this.item.lessonId);
        this.$emit('lesson-deleted');
        this.close();
        this.$toast.success('课程删除成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('删除失败：' + errorMessage);
      }
    }
  }
}
</script> 